
import fetch from './fetch'

// 修改密码
export function changePassword (data) {
  return fetch({
    url: 'index/changePassword',
    method: 'post',
    data
  })
}
// 账号管理页面
export function resetPassword (data) {
  return fetch({
    url: 'index/resetPassword',
    method: 'post',
    data
  })
}
export function getAccountList (params) {
  return fetch({
    url: 'index/getAccountList',
    method: 'get',
    params
  })
}
export function addAccount (data) {
  return fetch({
    url: 'index/addAccount',
    method: 'post',
    data
  })
}
export function editAccount (data) {
  return fetch({
    url: 'index/editAccount',
    method: 'post',
    data
  })
}
export function deleteAccount (data) {
  return fetch({
    url: 'index/deleteAccount',
    method: 'post',
    data
  })
}
// 配置页
export function getConfig (params) {
  return fetch({
    url: 'index/getConfig',
    method: 'get',
    params
  })
}
export function setConfig (data) {
  return fetch({
    url: 'index/setConfig',
    method: 'post',
    data
  })
}
export function initLoginInfo (params) {
  return fetch({
    url: 'index/initLoginInfo',
    method: 'get',
    params
  })
}
export function getProductSelectList (params) {
  return fetch({
    url: 'index/getProductSelectList',
    method: 'get',
    params
  })
}
// 产品列表页面
export function getProductList (params) {
  return fetch({
    url: 'index/getProductList',
    method: 'get',
    params
  })
}
export function addProduct (data) {
  return fetch({
    url: 'index/addProduct',
    method: 'post',
    data
  })
}
export function editProduct (data) {
  return fetch({
    url: 'index/editProduct',
    method: 'post',
    data
  })
}
export function getStockLog (params) {
  return fetch({
    url: 'index/getStockLog',
    method: 'get',
    params
  })
}
export function deleteProduct (data) {
  return fetch({
    url: 'index/deleteProduct',
    method: 'post',
    data
  })
}
export function addProduce (data) {
  return fetch({
    url: 'index/addProduce',
    method: 'post',
    data
  })
}
export function addProduceReport (data) {
  return fetch({
    url: 'index/addProduceReport',
    method: 'post',
    data
  })
}
export function getProductPicById (data) {
  return fetch({
    url: 'index/getProductPicById',
    method: 'post',
    data
  })
}
export function deleteProductPic (data) {
  return fetch({
    url: 'index/deleteProductPic',
    method: 'post',
    data
  })
}
// 添加客户订单接口暂时没用
export function addCustomerOrder (data) {
  return fetch({
    url: 'index/addCustomerOrder',
    method: 'post',
    data
  })
}
// 原料列表页面
export function getMaterialList (params) {
  return fetch({
    url: 'index/getMaterialList',
    method: 'get',
    params
  })
}
export function addMaterial (data) {
  return fetch({
    url: 'index/addMaterial',
    method: 'post',
    data
  })
}
export function editMaterial (data) {
  return fetch({
    url: 'index/editMaterial',
    method: 'post',
    data
  })
}
export function deleteMaterial (data) {
  return fetch({
    url: 'index/deleteMaterial',
    method: 'post',
    data
  })
}
export function addBuyOrder (data) {
  return fetch({
    url: 'index/addBuyOrder',
    method: 'post',
    data
  })
}
// 客户订单页面
export function getOrderList (params) {
  return fetch({
    url: 'index/getOrderList',
    method: 'get',
    params
  })
}
export function getDeliverLog (params) {
  return fetch({
    url: 'index/getDeliverLog',
    method: 'get',
    params
  })
}
// 生产派工单页面
export function getProduceList (params) {
  return fetch({
    url: 'index/getProduceList',
    method: 'get',
    params
  })
}
export function deleteProduce (data) {
  return fetch({
    url: 'index/deleteProduce',
    method: 'post',
    data
  })
}
// 生产日报单页面
export function createProduceReportExcel (params) {
  return fetch({
    url: 'index/createProduceReportExcel',
    method: 'get',
    params
  })
}
export function getProduceReportList (params) {
  return fetch({
    url: 'index/getProduceReportList',
    method: 'get',
    params
  })
}
export function deleteProduceReport (data) {
  return fetch({
    url: 'index/deleteProduceReport',
    method: 'post',
    data
  })
}
export function editProduceReport (data) {
  return fetch({
    url: 'index/editProduceReport',
    method: 'post',
    data
  })
}
// 通过日报审核
export function passProduceReport (data) {
  return fetch({
    url: 'index/passProduceReport',
    method: 'post',
    data
  })
}
// 原料采购单页面
export function createBuyOrderExcel (params) {
  return fetch({
    url: 'index/createBuyOrderExcel',
    method: 'get',
    params
  })
}
export function getSelectMaterial (params) {
  return fetch({
    url: 'index/getSelectMaterial',
    method: 'get',
    params
  })
}
export function getBuyOrderList (params) {
  return fetch({
    url: 'index/getBuyOrderList',
    method: 'get',
    params
  })
}
export function deleteBuyOrder (data) {
  return fetch({
    url: 'index/deleteBuyOrder',
    method: 'post',
    data
  })
}
export function updateCome (data) {
  return fetch({
    url: 'index/updateCome',
    method: 'post',
    data
  })
}
export function updateBuyOrder (data) {
  return fetch({
    url: 'index/updateBuyOrder',
    method: 'post',
    data
  })
}
